// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__i579J","open":"Menu_open__39V36","arrow":"Menu_arrow__2ccNh","option":"Menu_option__1-MfN"};